import { memo } from 'react'

import { useOpenRule } from '../hooks/useOpenRule'
import { useTranslation } from 'react-i18next'

import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import {
  selectIncidentRulesPageSize,
  setIncidentRulesPageSize,
} from '@/redux/ui/uiSlice'

import { getRuleRows } from '../utils/ruleRows'
import { RulesListType, RulesRefetchType } from '../utils/utils'
import { columns } from './Columns'
import { DataTable } from './DataTable'

export interface IncidentRulesTableIProps {
  rules: RulesListType
  totalCount: number
  refetch: RulesRefetchType
  isLoading?: boolean
}

export const IncidentRulesTable = memo(
  ({ rules, totalCount, refetch, isLoading }: IncidentRulesTableIProps) => {
    const dispatch = useAppDispatch()
    const { openRule } = useOpenRule()
    const { t } = useTranslation()
    const pageSize = useAppSelector(selectIncidentRulesPageSize)

    const onPageResize = (pageIndex: number) => {
      dispatch(setIncidentRulesPageSize(pageIndex))
    }

    // Shared with the dark table: skips edges without a rule id, so no row
    // links to `?id=undefined`.
    const tableData = getRuleRows(rules, t)

    return tableData ? (
      <DataTable
        columns={columns}
        data={tableData}
        isLoadingExternal={isLoading}
        onPageResize={onPageResize}
        onRowClick={openRule}
        pageSize={pageSize}
        refetch={refetch}
        total={totalCount}
      />
    ) : null
  }
)
